import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box'

import MyProfileTabRenderer from './MyProfileTabRenderer';

function MyProfile(props) {

    useEffect(() => {
        props.loadComponentData();
    }, []);

    return (
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>

                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to="/home">Acasa</Link>
                        <Typography color="text.primary">Profil personal</Typography>
                    </Breadcrumbs>
                </Box>

                <Box>
                    <Box style={{ display: "flex", marginBottom: 4 }}>
                        <h3>Profil Personal</h3>
                    </Box>
                </Box>
                <hr />

                <MyProfileTabRenderer client={props.client}/>

            </Stack>

        </Box>
        </Container>
    );
}

export default MyProfile;